import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GenericModal from './generic_modal';
import Warning from '../../components/warning';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import {injectIntl, FormattedHTMLMessage} from 'react-intl';

class DeleteProjectModal extends Component {
	render() {
		const {formatMessage} = this.props.intl;

		const content = (
			<div className={'default-warning-modal'}>
				<Warning messageId={'common.delete-project-title'} />
				<div style={{marginTop: '8px'}}>
					<FormattedHTMLMessage id="common.delete-project-info" style={{marginTop: '8px;'}} />
				</div>
			</div>
		);
		return (
			<GenericModal
				closeModal={this.props.closeModal}
				buttons={[
					{
						text: formatMessage({id: 'common.cancel'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'common.delete'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.RED,
						callback: this.props.deleteCallback,
						cy: 'modal-delete-task-button',
					},
				]}
				content={content}
			/>
		);
	}
}

DeleteProjectModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	deleteCallback: PropTypes.func.isRequired,
};
export default injectIntl(DeleteProjectModal);
